import React from 'react';
import ReviewShowcase from '../UI/ReviewShowcase';

/** Highlighted customer reviews shown on the landing page. */
const BestReviews = () => (
  <ReviewShowcase
    endpoint="/api/fetch-best-reviews"
    layout="grid"
    columns={4}
    limit={8}
    skeletonCount={8}
  />
);

export default BestReviews;
